import { call, fork, put, take, select } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import { refNumber } from '../refNumber';
import _ from 'lodash';

function* postRequestVessel(vesselRequest) {
    const response = yield call(api.postRequestVessel, vesselRequest);

    if (response.status === 200) {
        yield put({
            type: actionTypes.POST_VESSEL_REQUEST.SUCCESS,
            data: response.data,
            vesselRequest,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: `Success vessel request - ${vesselRequest.keyVesselOrder + 1}`,
                message: `${response.data.message}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield call(refNumber, response.data);
        return response;
    } else if (response.status === 409) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Vessel request prolonged',
                message: `${response.errors[0].messages[1].refNo}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });
        yield put({
            type: actionTypes.POST_VESSEL_REQUEST.SUCCESS,
            data: _.get(response, 'errors[0].messages[1]'),
            vesselRequest,
        });

        yield call(refNumber, { refNo: response.errors[0].messages[1].refNo });
        return response;
    } 
    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: `Error vessel request - ${vesselRequest.keyVesselOrder + 1}`,
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });
    
    yield put({
        type: actionTypes.POST_VESSEL_REQUEST.FAILURE,
        errors: response.errors,
        vesselRequest,
    });

    return response;
}

export function* watchPostRequestVessel() {
    while (true) {
        const { vesselRequest } = yield take(actionTypes.POST_VESSEL_REQUEST.REQUEST);
        yield fork(postRequestVessel, vesselRequest);
    }
}
/**
 *
 * */
function* getRequestsVessel(filter) {
    const response = yield call(api.getVesselMonitor, filter);
    // todo response with pagination
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_VESSEL_REQUESTS.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_VESSEL_REQUESTS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetRequestsVessel() {
    while (true) {
        const { filter } = yield take(actionTypes.GET_VESSEL_REQUESTS.REQUEST);
        yield fork(getRequestsVessel, filter);
    }
}

function* updateRequestsVessel(vesselRequestId, userId) {
    const response = yield call(api.changeUserVesselRequest, vesselRequestId, userId);
    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_VESSEL_REQUEST.SUCCESS,
            vesselRequestId,
            userId,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: vesselRequestId,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_VESSEL_REQUEST.FAILURE,
        errors: response.errors,
        vesselRequestId,
        userId,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: vesselRequestId,
            autoDismiss: 2,
        },
    });

    return response;
}

export function* watchUpdateRequestsVessel() {
    while (true) {
        const { vesselRequestId, userId } = yield take(actionTypes.UPDATE_VESSEL_REQUEST.REQUEST);
        yield fork(updateRequestsVessel, vesselRequestId, userId);
    }
}

function* deleteRequestsVessel(vesselId, requestId) {
    const response = yield call(api.deleteVesselRequest, vesselId, requestId);
    if (response.status === 200) {
        const store = yield select();

        yield put({
            type: actionTypes.DELETE_VESSEL_REQUEST.SUCCESS,
            vesselId,
            email: store.user.user.email,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: vesselId,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.DELETE_VESSEL_REQUEST.FAILURE,
        vesselId,
        error: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: vesselId,
            autoDismiss: 2,
        },
    });

    return response;
}

export function* watchDeleteRequestsVessel() {
    while (true) {
        const { vesselId, requestId } = yield take(actionTypes.DELETE_VESSEL_REQUEST.REQUEST);
        yield fork(deleteRequestsVessel, vesselId, requestId);
    }
}

export default [watchPostRequestVessel, watchDeleteRequestsVessel, watchGetRequestsVessel, watchUpdateRequestsVessel];



// WEBPACK FOOTER //
// ./app/sagas/vessels/requests.js